/* Nolae — About Us (/pages/ueber-uns).
 *
 * Built by about-us-theme/scripts/build_js.py: src/au-chrome.js followed by the
 * prototype's own scripts, copied verbatim from about-us/public/2/. Do not edit
 * here — edit the prototype, or src/au-chrome.js, and rebuild.
 *
 * Lenis is NOT started here; the theme's own smooth.js does that.
 */

/* ———— au-chrome.js ———— */
/* About Us — the chrome.
 *
 * What the prototype's public/2/glass.js did for its own stand-in header, done
 * for the theme's real one — the same approach as idol-a-z-theme/src/az-chrome.js
 * and release-calendar.js:
 *
 *   • the header slides away on a sustained scroll down and comes back on a
 *     longer scroll up, armed only once the hero has scrolled under it;
 *   • --chrome-top tells everything pinned below where to park, which is what
 *     the story stage's sticky offset is computed from;
 *   • the theme's header-color-adapt is neutralised (see below).
 *
 * The frosted band is NOT here. The prototype drew its own (body::before, fed
 * by glass.js) because its stand-in header had none; the live theme already
 * runs that exact mechanism — it is the one the prototype's was ported from —
 * and the only chrome this page pins is the header, which is what the theme
 * sizes the band to.
 */
(function () {
  "use strict";
  var root = document.documentElement;
  var header = document.querySelector('.shopify-section--header, [id^="shopify-section"][id$="__header"]');
  var page = document.querySelector(".nolae-au");
  if (!page) return;

  var HERO_ENTRY = 0.2;
  var DELTA = 2, HIDE_AFTER = 24, REVEAL_AFTER = 120;
  var up = false, lastY = window.scrollY, run = 0;

  function headerSticky() {
    if (!header) return false;
    var p = getComputedStyle(header).position;
    return p === "sticky" || p === "fixed";
  }

  /* Where the bottom of the pinned chrome is. The story stage pins against
     this, so it has to be published on every scroll, not only when the header
     moves — the header's own position drifts while it is sliding. */
  var lastTop = -1;
  function publishTop() {
    var top = 0;
    if (header && !up && headerSticky()) {
      top = Math.max(0, header.getBoundingClientRect().top) + header.offsetHeight;
    }
    top = Math.round(top);
    if (top !== lastTop) {
      root.style.setProperty("--chrome-top", top + "px");
      lastTop = top;
    }
  }

  /* Armed once the header's bottom edge reaches the hero's first fifth — or,
     on a phone, the "About Us" eyebrow, since the full-bleed banner above it is
     most of the screen there. Same rule as the prototype's glass.js. */
  function pastHeroEntry() {
    var hero = page.querySelector(".hero");
    if (!hero || !header) return true;
    var mark = window.innerWidth <= 819.98 && page.querySelector(".hero-eyebrow");
    var line;
    if (mark) {
      line = mark.getBoundingClientRect().top;
    } else {
      var r = hero.getBoundingClientRect();
      line = r.top + r.height * HERO_ENTRY;
    }
    return line <= header.offsetHeight;
  }

  function setUp(v) {
    // Never while a theme drawer is open — the cart and menu slide over the page.
    if (v && document.body.classList.contains("lock-all")) v = false;
    if (v === up) return;
    up = v;
    root.classList.toggle("nolae-chrome-up", v);
    publishTop();
    /* The header takes 0.32s to travel. Everything that measures against it —
       the story stage, the timeline's pin — hears only scroll events, so give
       them three across the transition rather than leaving them a frame
       behind. The prototype's glass.js does the same, for the same reason. */
    [80, 200, 340].forEach(function (ms) {
      setTimeout(function () { window.dispatchEvent(new Event("scroll")); }, ms);
    });
  }

  function autoHide() {
    if (!header) return;
    var y = window.scrollY;
    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) return;        // ignore sub-pixel jitter
    lastY = y;
    if (diff > 0 !== run > 0) run = 0;         // direction changed: start a new run
    run += diff;
    if (!pastHeroEntry()) { run = 0; setUp(false); return; }
    if (run >= HIDE_AFTER) setUp(true);
    else if (run <= -REVEAL_AFTER) setUp(false);
  }

  /* ————— Header link colours —————
     The theme's header-color-adapt section, once the header is `scrolled`,
     samples what is behind each nav link and forces it white over a dark patch.
     On this page that misfires the same way it did on the Release Calendar: the
     hero's dark scrim reads as dark, but the header has its own light surface,
     so the links go white on near-white — and the script bails as soon as the
     header un-scrolls without undoing it. Here the header only ever sits over
     the hero or the page's own white, so the theme's own colours are always
     right: whatever the adapter writes is taken straight back off.
     MutationObserver callbacks run before paint, so the white never shows. */
  var adapted = document.querySelectorAll(".header__linklist-link, .header__secondary-links .header__icon-wrapper svg");
  function unadapt(el) { if (el.style.getPropertyValue("color")) el.style.removeProperty("color"); }
  if (adapted.length && window.MutationObserver) {
    var mo = new MutationObserver(function (records) {
      records.forEach(function (r) { unadapt(r.target); });
    });
    [].forEach.call(adapted, function (el) {
      unadapt(el);
      mo.observe(el, { attributes: true, attributeFilter: ["style"] });
    });
  }

  function onScroll() { autoHide(); publishTop(); }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", publishTop);
  if (window.ResizeObserver && header) new ResizeObserver(publishTop).observe(header);
  publishTop();
})();

/* ———— hero-split.js ———— */
/* Nolae About Us — per-line split for the hero's entrance.
 *
 * The reference (sendpotion.com) staggers its headline one LINE at a time, each
 * line swinging up out of a backward tilt. Lines are not addressable in CSS, so
 * they have to be made into elements — and where a line breaks depends on the
 * width and on which font is loaded, so it cannot be written into the markup
 * either. This measures the real breaks and wraps them, then re-measures whenever
 * they could have changed.
 *
 * Method: wrap every word in a span, read each one's top, group the spans that
 * share a top into one block per line — then throw the word spans away again,
 * collapsing each line back to plain text. That last step matters for screen
 * readers: a paragraph split into one element per word is read badly by some, and
 * once the lines are known the words have served their purpose. What is left is
 * three blocks of ordinary text.
 *
 * Non-text children survive as single tokens: the inline gif keeps its place
 * mid-sentence, and "K-pop" keeps the nowrap span that stops it breaking at its
 * hyphen.
 *
 * Four groups use this: the hero, which plays on load, and "Meet the team",
 * "Culture at Nolae" and "Content House of K-pop", which each hold until the
 * reader reaches them. The
 * splitting is identical either way — WHEN the lines animate is a CSS question,
 * keyed off a class the relevant section's own script adds.
 *
 * If this never runs, the CSS leaves the hero as plain static text — the entrance
 * is additive, never a precondition for reading the page.
 *
 * Deliberately framework-free (IIFE, no imports, no build step) so it drops into a
 * Shopify Liquid section unchanged:
 *   {{ 'hero-split.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  /* Groups, not one flat list. Each group restarts the stagger index at 0, so
     the team's two blocks count 0,1,2... of their own rather than continuing
     from the hero's — sharing a counter would have handed the team's first line
     a delay several hundred ms long before it even started.
     Within a group the index DOES carry across elements, which is what makes
     the hero's eyebrow and headline read as one run of lines. */
  var GROUPS = [
    [".hero-eyebrow", ".hero-title"],
    [".story-title"],
    [".team-title", ".team-blurb"],
    [".cult-title", ".cult-blurb"],
    [".ch-title", ".ch-blurb"],
    [".tm-title", ".tm-blurb"],
  ];
  var lastWidth = -1;

  function tokenise(el) {
    // Words become spans; elements pass through whole.
    var tokens = [];
    var nodes = [].slice.call(el.childNodes);
    el.textContent = "";
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 3) {
        var parts = node.nodeValue.split(/(\s+)/);
        for (var j = 0; j < parts.length; j++) {
          if (!parts[j]) continue;
          if (/^\s+$/.test(parts[j])) {
            // Real whitespace, so the browser still has its break opportunities.
            el.appendChild(document.createTextNode(parts[j]));
          } else {
            var w = document.createElement("span");
            w.textContent = parts[j];
            el.appendChild(w);
            tokens.push(w);
          }
        }
      } else if (node.nodeType === 1) {
        el.appendChild(node);
        tokens.push(node);
      }
    }
    return tokens;
  }

  function split(el, startIndex) {
    if (el.__orig == null) el.__orig = el.innerHTML;
    // Hidden across the rebuild so the un-split text is never painted; both
    // happen in one task, so there is no flash either way.
    el.style.visibility = "hidden";
    el.classList.remove("is-split");
    el.innerHTML = el.__orig;

    var tokens = tokenise(el);
    if (!tokens.length) { el.style.visibility = ""; return startIndex; }

    /* Group into lines by each token's vertical CENTRE, against half a line-height
       of tolerance.
       Not by rect top with a small tolerance, which is the obvious version and is
       wrong here: tokens on one line do not share a top. A word's box is its
       glyphs, the inline gif's is 75px tall and vertically centred, and the two
       differ by enough to look like separate lines — which split the sentence's
       middle line into three and stretched the headline from 234 to 390.
       Centres of tokens on one line agree closely, while the next line's are a
       full line-height away, so half a line-height separates them cleanly whatever
       is sitting in the text. */
    var lh = parseFloat(getComputedStyle(el).lineHeight);
    if (!lh || isNaN(lh)) lh = parseFloat(getComputedStyle(el).fontSize) * 1.3 || 20;
    var tol = lh * 0.5;

    var lines = [];
    var lineCentre = null;
    for (var i = 0; i < tokens.length; i++) {
      var box = tokens[i].getBoundingClientRect();
      /* A token that is not rendered has no position to group by, and its zero
         rect sits nowhere near the real lines — so it would start a line of its
         own. That is not hypothetical: the inline gif is display:none at the
         mobile breakpoint, where it split the middle of the sentence in three and
         left the headline a line taller than it should be. Carry such tokens along
         with whatever line is open instead. */
      if (!box.width && !box.height) {
        if (!lines.length) lines.push([]);
        lines[lines.length - 1].push(tokens[i]);
        continue;
      }
      var centre = box.top + box.height / 2;
      if (lineCentre === null || Math.abs(centre - lineCentre) > tol) {
        lines.push([]);
        lineCentre = centre;
      }
      lines[lines.length - 1].push(tokens[i]);
    }

    // Rebuild as one block per line, collapsing the word spans back to text.
    var frag = document.createDocumentFragment();
    for (var l = 0; l < lines.length; l++) {
      var line = document.createElement("span");
      line.className = "hero-line";
      line.style.setProperty("--i", String(startIndex + l));
      var group = lines[l];
      for (var t = 0; t < group.length; t++) {
        var tok = group[t];
        /* A <br> did its job during measurement — it is why this group is a
           separate line at all. Carrying it into the rebuilt line would add an
           empty line box below the text and inflate the block's height. */
        if (tok.tagName === "BR") continue;
        var isWord = tok.tagName === "SPAN" && !tok.className;
        if (isWord) {
          var prev = line.lastChild;
          var text = tok.textContent;
          // Put the separating space back between words on the same line.
          if (t > 0) text = " " + text;
          if (prev && prev.nodeType === 3) prev.nodeValue += text;
          else line.appendChild(document.createTextNode(text));
        } else {
          if (t > 0) line.appendChild(document.createTextNode(" "));
          line.appendChild(tok);
        }
      }
      frag.appendChild(line);
    }
    el.textContent = "";
    el.appendChild(frag);

    el.style.visibility = "";
    el.classList.add("is-split");
    return startIndex + lines.length;
  }

  function run() {
    for (var g = 0; g < GROUPS.length; g++) {
      var index = 0;
      for (var i = 0; i < GROUPS[g].length; i++) {
        var el = document.querySelector(GROUPS[g][i]);
        if (el) index = split(el, index);
      }
    }
    lastWidth = window.innerWidth;
  }

  function onResize() {
    // Only width can change where a line breaks; height cannot, and on mobile it
    // changes constantly as the address bar comes and goes.
    if (window.innerWidth === lastWidth) return;
    run();
  }

  function init() {
    run();
    window.addEventListener("resize", onResize);
    // The fallback face breaks lines somewhere else, so re-split once Omnes lands.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ———— story-scroll.js ———— */
/* Nolae About Us — scroll-linked "Our Story" stage.
 *
 * Publishes a single custom property, --p (0 → 1), on the .story element for as
 * long as its stage is pinned. Everything visual — the wavy image wipe, the
 * paragraph crossfade — lives in CSS and reads that number; this file only
 * reports progress.
 *
 * On .story and not on <html>: a custom property on the root invalidates style
 * for the whole document, and this writes on every scroll frame. Every rule
 * that reads --p is inside the section, so that is where the invalidation
 * belongs. The stylesheet's own var() fallbacks supply the initial 0.
 *
 * Progress is derived from live geometry — the section's rect against the
 * stage's own sticky offset — rather than hard-coded pixel offsets, so it stays
 * correct regardless of header height, viewport, font loading, or the header
 * having auto-hidden (which changes where the stage pins).
 *
 * Deliberately framework-free (IIFE, no imports, no build step) so it drops
 * into a Shopify Liquid section unchanged:
 *   {{ 'story-scroll.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  var section = null;
  var stage = null;
  /* The element that actually pins — the heading and the stage together. The
     stage is still needed separately, for the deck slack in tail(). */
  var pinBox = null;
  var dots = [];
  var ticking = false;
  var last = -1;
  var lastArrive = -1;
  var lastBoxH = -1;
  var currentStep = 0;

  function find() {
    section = document.querySelector(".story");
    stage = section && section.querySelector(".story-stage");
    pinBox = section && section.querySelector(".story-pin");
    dots = section ? [].slice.call(section.querySelectorAll(".story-dot")) : [];
    if (section && stage) bindDots();
    return !!(section && stage && pinBox);
  }

  /* Where --p rests for a given step, read from the stylesheet rather than
     duplicated here. The ramp boundaries live in one block of CSS next to the
     budget diagram, and a copy of those numbers in JS is a copy that goes stale
     the first time the pacing is retuned. */
  function restOf(step) {
    var v = parseFloat(getComputedStyle(section).getPropertyValue("--rest-" + step));
    return isNaN(v) ? 0 : v;
  }

  function set(p) {
    // Skip sub-perceptual updates so we are not touching style every frame
    // during momentum scrolling.
    if (Math.abs(p - last) < 0.001) return;
    last = p;
    section.style.setProperty("--p", p.toFixed(4));
  }

  /* The section's scroll geometry, in one place because two callers need it:
     the scroll handler turning position into --p, and a dot click turning a
     target --p back into a scroll position. If those two ever disagreed, a dot
     would land somewhere other than where it points. */
  function geometry() {
    var r = section.getBoundingClientRect();
    /* The distance the box spends pinned: everything in the section that is not
       the pinned box itself. Read from the live box rather than the
       stylesheet's vh figure, because its height is capped against the
       viewport. The PINNED box, not the stage — the heading pins with the cards
       and its height is part of what does not travel, so measuring the stage
       alone would claim the heading's height as travel the box cannot deliver
       and the story would still be finishing as the cards left the screen. */
    var boxH = pinBox.offsetHeight;
    /* Keep the published height honest. tail() takes a first reading on load,
       fonts and resize, but the deck is as tall as its tallest card and that
       settles as images decode — a stale number parks the pinned box a few
       pixels off centre. offsetHeight is already being read here every frame
       for the travel, so this costs nothing but the write, and it only writes
       when the value actually moves. */
    if (boxH !== lastBoxH) {
      lastBoxH = boxH;
      section.style.setProperty("--group-measured", boxH + "px");
    }
    var travel = r.height - boxH;
    if (travel <= 0) return null;

    /* Where the box parks. It is a var() in the stylesheet — and it moves when
       the header hides — so it has to be read, not assumed. */
    var pin = parseFloat(getComputedStyle(pinBox).top) || 0;

    /* Clamp the travel to what can actually be scrolled.
       The section asks for `travel` px of pinned scrolling, but it only gets that
       if enough page follows it. This is the last section, so the document ends
       while the stage is still pinned: the final stretch is unreachable, --p tops
       out short of 1, and the stage sits pinned and finished doing nothing —
       measured at 190px of dead scroll here, and it gets worse on taller
       viewports because the centred stage leaves more room below it.
       Normalising against the reachable distance instead means --p always ends at
       exactly 1 on the last scrollable pixel, whatever follows the section. */
    var pinStart = r.top + window.scrollY - pin;
    var reachable = (document.documentElement.scrollHeight - window.innerHeight) - pinStart;
    if (reachable > 0 && reachable < travel) travel = reachable;

    return { top: r.top, pin: pin, pinStart: pinStart, travel: travel };
  }

  function update() {
    ticking = false;
    if ((!section || !section.isConnected) && !find()) return;

    var g = geometry();
    if (!g) { set(0); return; }

    // 0 the moment the section reaches the pin point, 1 when it leaves.
    /* ————— The approach —————
     * --arrive is 0 a full viewport before the pinned box reaches its parked
     * position and 1 once it is there, and it STAYS 1 for the whole pinned
     * scrub (g.top only goes further past g.pin, and the clamp holds it).
     * The mobile deck rides it to open out to full width as the section locks
     * in; see .story-cards-m. Published unconditionally — the desktop
     * stylesheet simply never reads it. */
    var away = (g.top - g.pin) / window.innerHeight;
    var arrive = 1 - (away < 0 ? 0 : away > 1 ? 1 : away);
    if (Math.abs(arrive - lastArrive) >= 0.002) {
      lastArrive = arrive;
      section.style.setProperty("--arrive", arrive.toFixed(3));
    }

    var raw = (g.pin - g.top) / g.travel;
    var p = raw < 0 ? 0 : raw > 1 ? 1 : raw;
    set(p);
    // Strictly between the two is the only time the stage is actually pinned.
    resistance(raw > 0 && raw < 1);
    markCurrent(p);
  }

  /* ————— Dots as controls —————
   * Each dot scrolls to where its own step sits at rest. The target is derived
   * from the same geometry() the scroll handler uses and the same --rest-N the
   * stylesheet declares, so a dot always lands exactly on the step it draws.
   *
   * Lenis animates it when present; otherwise native smooth scrolling covers it.
   * The wheel resistance does not apply here — it scales wheel deltas, and this
   * is a programmatic scroll — so a click crosses the section at full speed
   * however slow the wheel has been made.
   */
  function bindDots() {
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].__bound) continue;
      dots[i].__bound = true;
      dots[i].addEventListener("click", onDotClick);
    }
  }

  function onDotClick(e) {
    var step = parseInt(e.currentTarget.getAttribute("data-step"), 10);
    var g = geometry();
    if (!g || !step) return;
    var y = g.pinStart + restOf(step) * g.travel;
    var l = window.__lenis;
    if (l) l.scrollTo(y, { duration: 1.1 });
    else window.scrollTo({ top: y, behavior: "smooth" });
  }

  /* Marks the step a reader would say they are on — the one whose rest point is
     nearest — so the control reports its state to assistive tech instead of only
     looking active. Written only when it changes, not every frame. */
  function markCurrent(p) {
    if (!dots.length) return;
    var best = 1, bestD = Infinity;
    for (var i = 0; i < dots.length; i++) {
      var step = parseInt(dots[i].getAttribute("data-step"), 10);
      var d = Math.abs(p - restOf(step));
      if (d < bestD) { bestD = d; best = step; }
    }
    if (best === currentStep) return;
    currentStep = best;
    for (var j = 0; j < dots.length; j++) {
      var s = parseInt(dots[j].getAttribute("data-step"), 10);
      if (s === best) dots[j].setAttribute("aria-current", "true");
      else dots[j].removeAttribute("aria-current");
    }
  }

  /* ————— Scroll resistance while the stage is pinned —————
   * Halves the wheel gain, so getting through the section takes twice the
   * scrolling without the section itself being any longer. Doing it as input
   * gain rather than by doubling the travel matters: doubling the travel would
   * add another 180vh to the document and put back exactly the dead scrolling
   * that was just taken out.
   *
   * The multiplier has to be written on lenis.virtualScroll.options, NOT on
   * lenis.options — Lenis hands VirtualScroll its own options object at
   * construction and the wheel handler reads the multiplier from that one, so
   * setting it on the Lenis instance looks right and does nothing.
   *
   * Wheel and trackpad only. Touch is left alone because Lenis runs with
   * syncTouch off and never intercepts it, so phones keep native momentum —
   * slowing that would mean taking over touch scrolling wholesale.
   *
   * Entirely optional: no Lenis (absent, or declined for reduced motion) means
   * no resistance and the section simply scrolls at normal speed.
   */
  var SLOW = 0.5;
  var resisting = null;
  var base = null;

  function resistance(pinned) {
    var l = window.__lenis;
    var vs = l && l.virtualScroll;
    if (!vs || !vs.options) return;
    if (pinned === resisting) return;
    // Capture the theme's own multiplier once, rather than assuming it is 1.
    if (base === null) base = vs.options.wheelMultiplier;
    resisting = pinned;
    vs.options.wheelMultiplier = pinned ? base * SLOW : base;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  /* ————— The boundary into "Our Story" —————
   * Publishes --story-tail on .tl: the empty box this section leaves below its
   * last card, which the timeline's own margin then subtracts so the gap comes
   * to the page's 87 like every other mobile boundary.
   *
   * It has to be measured because it swings with BOTH axes and neither term is
   * expressible in CSS. The stage is viewport-tall with the deck centred in it,
   * so the space below the card is (stage - deck) / 2: the stage follows the
   * WINDOW's height, and the deck's own height follows the card's WIDTH, via a
   * square photo and a line of copy that no calc() can predict. Left as a
   * fixed margin it measured 6 on a 667-tall phone and 131 on a 932 — one
   * number was only ever going to be right on the screen it was taken from.
   *
   * Measured at the story's END position, which is where the boundary is read:
   * the stage is sticky, so the card's document position travels with it and
   * only settles once it unpins.
   *
   * Desktop shows no deck, so the property is removed there and the .tl rule
   * falls back to its own value. Same if this never runs. */
  function tail() {
    var section = document.querySelector(".story");
    var tl = document.querySelector(".tl");
    if (!section || !tl) return;
    var deck = section.querySelector(".story-cards-m");
    var stage = section.querySelector(".story-stage");
    var pinBoxEl = section.querySelector(".story-pin");
    /* offsetParent is null for a display:none element — the desktop case. There
       the stage has a fixed height and --group-h is exact, so both measured
       properties come off and the stylesheet's own values take over. */
    if (!deck || !stage || !deck.offsetParent) {
      tl.style.removeProperty("--story-tail");
      section.style.removeProperty("--group-measured");
      return;
    }
    /* What the pinned box ACTUALLY measures. On mobile the stage is sized by
       the deck rather than by the viewport, so --group-h — which is built from
       the viewport-derived --stage-h — overstates it, and centring the box on
       that number would park the visible content high by half the difference.
       Published here rather than computed in CSS because only layout knows how
       tall the deck's tallest card came out. */
    if (pinBoxEl) {
      section.style.setProperty("--group-measured", pinBoxEl.offsetHeight + "px");
    }
    /* The WHOLE surplus, not half of it: the deck is top-aligned in the stage,
       so all of the leftover is below it. It was /2 while the deck centred. */
    var t = stage.offsetHeight - deck.offsetHeight;
    tl.style.setProperty("--story-tail", t.toFixed(1) + "px");
  }

  function init() {
    if (!find()) return;
    update();
    tail();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    window.addEventListener("resize", tail);
    window.addEventListener("orientationchange", tail);
    // Late webfont/image loads change the geometry underneath us.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update).then(tail);
    }
    window.addEventListener("load", function () { update(); tail(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ———— timeline-scroll.js ———— */
/* Nolae About Us — scroll-linked "Our Story" timeline.
 *
 * Publishes --pe (0 → 1) on the .tl element while its stage is pinned. The CSS
 * translates both tracks off that one number; this file only reports progress
 * and flips state classes. Same division of labour as story-scroll.js, and
 * framework-free for the same reason — it ships to a Shopify Liquid section
 * unchanged:
 *   {{ 'timeline-scroll.js' | asset_url | script_tag }}
 *
 * --pe is EASED progress, not raw: the raw ratio is pushed through a per-year
 * staircase — each of the six year-to-year segments holds still for REST of its
 * length at both ends and glides (smoothstep) between. That gives every year a
 * plateau where its cards can actually be read, without the CSS needing a
 * staircase function it cannot express. The easing is still just a number
 * published to CSS; all drawing stays in the stylesheet. Because each plateau
 * sits exactly at i/6, the arrows' rest targets and the class-switch midpoints
 * need no separate table of stops.
 */
(function () {
  "use strict";

  // Fraction of each year-to-year segment spent resting at either end.
  var REST = 0.3;
  /* Overshoot on arrival. The track runs a little past the year and comes back,
     which the eye reads as something physical coming to rest — the nearest a web
     page gets to the detent a trackpad would give if browsers exposed haptics.
     Tuned by the standard back-ease peak, 4s^3 / (27(s+1)^2): 0.8 puts the peak
     at ~2.4% of a segment, about 8px at the desktop column pitch. Enough to
     register, small enough that nobody reads it as a glitch. */
  var BACK = 0.8;
  /* Settle-to-nearest-year, i.e. scroll snapping. Deliberately NOT CSS
     scroll-snap: Lenis writes scrollTop every frame and the browser's snap
     engine treats each write as a finished scroll, so the two fight and the
     page jitters — Lenis documents scroll-snap as unsupported. Going through
     lenis.scrollTo instead means the snap IS a Lenis animation and cannot
     disagree with it. */
  var IDLE = 140;    // ms of no scroll input before settling
  var SNAP_MS = 450; // settle duration
  /* Project boundary: desktop >= 820, mobile < 820. Written as 819.98 so 820
     itself lands on the desktop side, matching globals.css and StoreHeader. */
  var MOBILE = "(max-width: 819.98px)";
  // How long the scroll must be quiet before the ruler marks the year.
  var IDLE_MARK = 160;

  var section = null;
  var stage = null;
  var cols = [];     // BOTH tracks' columns — years and cards flip together.
  var arrows = [];
  var ticking = false;
  var last = -1;
  var lastRawPub = -1;
  var lastRaw = 0;
  var current = -1;
  /* The two layouts do not necessarily have the same number of stops, so the
     segment count is per layout rather than one shared number.
       stepsD  desktop: one stop per YEAR — a year shows its cards side by side.
       stepsM  mobile:  one stop per CARD. The frame's single 211-wide card slot
               cannot pair two pictures with two captions legibly, so a year
               carrying two milestones repeats and the reader swipes through
               its cards instead. No year does at the moment, which makes the
               two counts equal — today, not by construction.
     Everything downstream asks steps() and gets the right one for whatever is
     on screen, which also means a window resized across 820 picks up the other
     count without anything being re-measured. */
  var stepsD = 0;
  var stepsM = 0;

  function segments(nodes) {
    var n = 0;
    for (var i = 0; i < nodes.length; i++) {
      var idx = parseInt(nodes[i].getAttribute("data-i"), 10) + 1;
      if (idx > n) n = idx;
    }
    return Math.max(1, n - 1);
  }

  function steps() {
    return isMobile() ? stepsM : stepsD;
  }

  function find() {
    section = document.querySelector(".tl");
    stage = section && section.querySelector(".tl-stage");
    if (!section || !stage) return false;
    /* Both layouts at once. The desktop stage marks its stop on .tl-col; the
       mobile block marks the same index on .tl-m-slide, and neither cares
       which is on screen — matching on the data-i attribute rather than on a
       class keeps mark() ignorant of the layout. */
    cols = [].slice.call(section.querySelectorAll("[data-i]"));
    arrows = [].slice.call(section.querySelectorAll(".tl-arrow"));
    /* Counted per layout, from that layout's own stops. */
    stepsD = segments(stage.querySelectorAll("[data-i]"));
    var m = section.querySelector(".tl-m");
    stepsM = m ? segments(m.querySelectorAll("[data-i]")) : stepsD;
    bindArrows();
    bindSwipe();
    return true;
  }

  function ease(p) {
    var st = steps();
    var s = p * st;
    var i = Math.floor(s);
    if (i >= st) return 1;
    var f = s - i;
    if (f <= REST) return i / st;
    if (f >= 1 - REST) return (i + 1) / st;
    var t = (f - REST) / (1 - 2 * REST);
    /* Back-out rather than smoothstep: same glide, but it carries a little past
       1 and returns, so the year lands instead of merely arriving. Both ends
       still hit exactly 0 and 1, so the plateaus stay dead flat. */
    var u = t - 1;
    return (i + 1 + u * u * ((BACK + 1) * u + BACK)) / st;
  }

  /* Two progresses, and the difference is the whole character of each layout.
       --pe  EASED: holds still on each year, glides between, overshoots on
             arrival. What the desktop's horizontal track rides.
       --pr  RAW: strictly linear with scroll. What the mobile conveyor rides,
             because there the decks are one continuous column and any hold
             reads as the information being swapped out and refreshed rather
             than flowing past. Linear means the deck moves exactly as far as
             the finger does.
     Both are published every update; each breakpoint's CSS picks one. */
  function set(p) {
    var pe = ease(p);
    if (Math.abs(pe - last) < 0.0005 && Math.abs(p - lastRawPub) < 0.0005) return;
    last = pe;
    lastRawPub = p;
    section.style.setProperty("--pe", pe.toFixed(4));
    section.style.setProperty("--pr", p.toFixed(4));
  }

  /* Same shape as story-scroll's geometry(), for the same reason: the scroll
     handler turns position into progress, an arrow click turns a target
     progress back into a position, and the two must not disagree. Includes the
     reachable-travel clamp because this is now the LAST section — the document
     can end while the stage is still pinned, and normalising against what can
     actually be scrolled is what lets 2026 arrive on the final pixel. */
  function geometry() {
    var r = section.getBoundingClientRect();
    var travel = r.height - stage.offsetHeight;
    if (travel <= 0) return null;
    var pin = parseFloat(getComputedStyle(stage).top) || 0;
    var pinStart = r.top + window.scrollY - pin;
    var reachable = (document.documentElement.scrollHeight - window.innerHeight) - pinStart;
    if (reachable > 0 && reachable < travel) travel = reachable;
    return { top: r.top, pin: pin, pinStart: pinStart, travel: travel };
  }

  function update() {
    ticking = false;
    if ((!section || !section.isConnected) && !find()) return;
    /* MOBILE has no pinned stage to read a year out of — the arrows own the
       index. Falling through would be actively wrong, not merely wasteful:
       .tl-stage is display:none there, so its offsetHeight is 0, geometry()
       still returns a travel, and every scroll frame would mark() the year
       back to whatever the page position implied and undo the reader's taps. */
    if (isMobile()) { mobileSync(); return; }
    var g = geometry();
    if (!g) { set(0); mark(0); return; }
    var raw = (g.pin - g.top) / g.travel;
    lastRaw = raw = raw < 0 ? 0 : raw > 1 ? 1 : raw;
    set(raw);
    mark(Math.round(raw * steps()));
    armSettle(raw > 0 && raw < 1);
    armIdle();
  }

  /* ————— Settled state —————
   * The mobile ruler flows continuously with the scroll, which is right while
   * the reader is moving but leaves nothing actually POINTING at the year once
   * they stop. This flags the quiet moment; the stylesheet turns the tick at
   * the marker pink and long in response.
   *
   * Only the class is managed here, and only when it actually changes, because
   * this is called on every scroll frame and touching classList each time
   * would invalidate style for nothing. Everything about how the settled state
   * LOOKS — and the fact that it eases in rather than popping — lives in CSS.
   */
  var idleClassTimer = null;
  var idleOn = false;

  function setIdle(on) {
    if (on === idleOn) return;
    idleOn = on;
    if (on) section.classList.add("is-idle");
    else section.classList.remove("is-idle");
  }

  function armIdle() {
    setIdle(false);
    if (idleClassTimer) clearTimeout(idleClassTimer);
    idleClassTimer = setTimeout(function () { setIdle(true); }, IDLE_MARK);
  }

  /* ————— Settle to the nearest year —————
   * Fires only when the reader has stopped mid-transition. Stopping ON a
   * plateau is left completely alone: the year is already settled and readable,
   * and pulling someone who parked there — possibly to read — would be a
   * hijack. So this finishes a movement the reader began and abandoned; it
   * never starts one.
   *
   * Skipped entirely under prefers-reduced-motion, where an unrequested
   * animated scroll is exactly what the setting is asking us not to do.
   */
  var idleTimer = null;
  var touching = false;
  var settling = false;

  function reduced() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function armSettle(pinned) {
    if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
    if (!pinned || settling || touching || reduced()) return;
    /* Never on mobile. The settle exists to finish an abandoned glide BETWEEN
       plateaus; the mobile conveyor is linear and has no plateaus, so every
       resting position would look "mid-glide" and the page would tug itself a
       little every time the reader stopped — the opposite of the continuous
       scroll this layout is for. */
    if (window.matchMedia && window.matchMedia(MOBILE).matches) return;
    idleTimer = setTimeout(settle, IDLE);
  }

  function settle() {
    idleTimer = null;
    var g = geometry();
    if (!g) return;
    var s = lastRaw * steps();
    var i = Math.floor(s);
    var f = s - i;
    // On a plateau already — nothing to finish.
    if (f <= REST || f >= 1 - REST) return;

    var idx = Math.round(s);
    var y = g.pinStart + (idx / steps()) * g.travel;
    if (Math.abs(window.scrollY - y) < 2) return;

    settling = true;
    var l = window.__lenis;
    if (l) l.scrollTo(y, { duration: SNAP_MS / 1000 });
    else window.scrollTo({ top: y, behavior: "smooth" });
    setTimeout(function () { settling = false; }, SNAP_MS + 120);
  }

  /* Flips the active year — colour, taller line, visible cards — on every
     column that carries the index, across both tracks at once. Also parks
     aria-disabled on whichever arrow points off the end. */
  function mark(idx) {
    if (idx === current) return;
    current = idx;
    for (var i = 0; i < cols.length; i++) {
      var on = parseInt(cols[i].getAttribute("data-i"), 10) === idx;
      cols[i].classList.toggle("is-on", on);
    }
    for (var j = 0; j < arrows.length; j++) {
      var dir = parseInt(arrows[j].getAttribute("data-dir"), 10);
      var dead = (dir < 0 && idx <= 0) || (dir > 0 && idx >= steps());
      arrows[j].setAttribute("aria-disabled", dead ? "true" : "false");
    }
  }

  function bindArrows() {
    for (var i = 0; i < arrows.length; i++) {
      if (arrows[i].__bound) continue;
      arrows[i].__bound = true;
      arrows[i].addEventListener("click", onArrow);
    }
  }

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia(MOBILE).matches);
  }

  /* MOBILE: the arrows ARE the navigation — there is no pinned stage to scroll
     and no scroll position to derive a year from. So the index is held here and
     written out as --mi, which the stylesheet transitions; the comb glides and
     every tick's lens maths rides that same interpolated number.
     .is-idle is dropped for the length of the glide and restored on arrival,
     which is the identical mechanism the desktop settle uses — so the pointer
     grows into the year exactly as it did when scrolling drove it. */
  var mIdx = 0;
  var mGlide = null;
  var mReady = false;

  /* Holds the mobile view at whatever the arrows last set. Both mark() and
     setIdle() no-op when nothing changed, so this is cheap to call on every
     scroll frame; only the first call writes --mi. */
  function mobileSync() {
    var m = section.querySelector(".tl-m");
    if (!m) return;
    if (!mReady) {
      mReady = true;
      m.style.setProperty("--mi", String(mIdx));
    }
    mark(mIdx);
    /* Not mid-glide: scrolling the page must not light the pointer before the
       comb has finished travelling. */
    if (!mGlide) setIdle(true);
  }

  function mobileGo(dir) {
    var next = mIdx + dir;
    if (next < 0 || next > steps()) return;
    mIdx = next;
    var m = section.querySelector(".tl-m");
    if (m) m.style.setProperty("--mi", String(mIdx));
    mark(mIdx);
    /* Pointer goes plain while the comb is moving, and points again when it
       stops. Kept slightly longer than the CSS glide so it cannot re-light
       mid-travel. */
    setIdle(false);
    if (mGlide) clearTimeout(mGlide);
    mGlide = setTimeout(function () { mGlide = null; setIdle(true); }, 580);
  }

  /* ————— MOBILE: dragging the ruler —————
   * The comb is a scrubber, so it should answer to a finger as well as to the
   * arrows. This is a LIVE drag, not a flick-and-jump: --mi takes fractional
   * values while the finger is down, which the tick lens already understands,
   * so the comb tracks 1:1 and the year, card and copy change under the finger.
   * Release snaps to the nearest year and hands back to the same glide the
   * arrows use.
   *
   * The axis is decided once, on the first few pixels of movement: past the
   * threshold a mostly-horizontal move becomes a scrub and a mostly-vertical
   * one is left alone, so the page still scrolls normally through the section.
   * touch-action: pan-y in the stylesheet is what lets both coexist without
   * preventDefault — which in turn is why these listeners can stay passive.
   *
   * A tap never scrubs: nothing happens until the threshold is crossed, so the
   * arrow buttons inside the block keep working normally.
   */
  function bindSwipe() {
    var m = section.querySelector(".tl-m");
    var ruler = section.querySelector(".tl-m-ruler");
    if (!m || !ruler || m.__swipe) return;
    m.__swipe = true;

    var THRESHOLD = 6; // px of movement before the axis is decided
    var startX = 0, startY = 0, startMi = 0;
    var deciding = false, dragging = false, mi = 0;

    function pxPerYear() {
      /* A year is M_PER_YEAR (8) ticks and the comb's pitch is the ruler's own
         width / 32, so one year is exactly a quarter of the ruler. Measured
         rather than assumed, because the ruler is sized off the viewport. */
      var w = ruler.getBoundingClientRect().width;
      return Math.max(1, w / 4);
    }

    function down(e) {
      if (!isMobile() || e.button > 0) return;
      startX = e.clientX; startY = e.clientY;
      startMi = mIdx; mi = mIdx;
      deciding = true; dragging = false;
    }

    function move(e) {
      if (!deciding && !dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (deciding) {
        if (Math.abs(dx) < THRESHOLD && Math.abs(dy) < THRESHOLD) return;
        deciding = false;
        /* Vertical wins: the reader is scrolling the page, not scrubbing. */
        if (Math.abs(dy) >= Math.abs(dx)) return;
        dragging = true;
        m.classList.add("is-dragging");
        if (mGlide) { clearTimeout(mGlide); mGlide = null; }
        setIdle(false);
        if (e.pointerId != null && m.setPointerCapture) {
          try { m.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      /* Dragging LEFT moves the comb left, which brings later years to the
         centre — so the index goes up as dx goes negative. */
      mi = startMi - dx / pxPerYear();
      mi = mi < 0 ? 0 : mi > steps() ? steps() : mi;
      m.style.setProperty("--mi", mi.toFixed(4));
      mark(Math.round(mi));
    }

    function up() {
      deciding = false;
      if (!dragging) return;
      dragging = false;
      m.classList.remove("is-dragging");
      /* Snap to the nearest year, through the same transition the arrows use,
         and let the pointer light up once it has landed. */
      mIdx = Math.round(mi);
      m.style.setProperty("--mi", String(mIdx));
      mark(mIdx);
      if (mGlide) clearTimeout(mGlide);
      mGlide = setTimeout(function () { mGlide = null; setIdle(true); }, 580);
    }

    m.addEventListener("pointerdown", down, { passive: true });
    m.addEventListener("pointermove", move, { passive: true });
    m.addEventListener("pointerup", up, { passive: true });
    m.addEventListener("pointercancel", up, { passive: true });
  }

  function onArrow(e) {
    var dir = parseInt(e.currentTarget.getAttribute("data-dir"), 10);
    if (!dir) return;
    if (isMobile()) return mobileGo(dir);
    var g = geometry();
    if (!g) return;
    var idx = Math.round(lastRaw * steps()) + dir;
    if (idx < 0 || idx > steps()) return;
    var y = g.pinStart + (idx / steps()) * g.travel;
    settling = true;
    if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
    var l = window.__lenis;
    if (l) l.scrollTo(y, { duration: 1.0 });
    else window.scrollTo({ top: y, behavior: "smooth" });
    setTimeout(function () { settling = false; }, 1120);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function init() {
    if (!find()) return;
    update();
    armIdle();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    /* Touch momentum keeps firing scroll events, but a held finger does not —
       without this the settle would fire while the reader is mid-drag and yank
       the page out from under them. */
    window.addEventListener("touchstart", function () {
      touching = true;
      if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
    }, { passive: true });
    window.addEventListener("touchend", function () { touching = false; }, { passive: true });
    window.addEventListener("touchcancel", function () { touching = false; }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    window.addEventListener("load", update);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ———— team-drop.js ———— */
/* Nolae About Us — "Meet the team" entrance.
 *
 * Two classes, two different moments, and they are separate because the things
 * they start are in different halves of the section:
 *
 *   .is-dropped  the heading's per-line rise, when the HEADING is readable.
 *   .is-spread   the chips coming out of their pile, when the CHIP FIELD is
 *                reached — which on a laptop is most of a screen later. Firing
 *                both off the heading would spend the spread below the fold and
 *                the reader would arrive to find it already over.
 *
 * .is-piled is added at start-up and is what puts the chips in a heap at all;
 * without this file they sit in their frame positions and the section is
 * simply static. The stack, the angles, the stagger and the settle are all CSS.
 *
 * Once per page load, by design — the brief is "when someone scrolls to this
 * section for the very first time", so the observer disconnects after firing
 * and scrolling back up does not replay it.
 *
 * IntersectionObserver rather than a scroll handler: the drop needs one
 * threshold crossing, not a position on every frame, and the observer costs
 * nothing while the section is off-screen. Where it is missing the chips are
 * simply shown in place (see the fallback below) — the animation is decoration,
 * never a precondition for reading the page.
 *
 * Deliberately framework-free (IIFE, no imports, no build step) so it drops
 * into a Shopify Liquid section unchanged:
 *   {{ 'team-drop.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  /* Enough of the section showing that the chips' landing zone is on screen —
     they sit in the lower third of the frame, so firing at the very first pixel
     would spend the whole animation below the fold. */
  var VISIBLE = 0.35;

  /* What "arrived" means, measured off the HEADING, not the section. The
     section-fraction test fired the moment 35% of the section had crossed the
     bottom edge — on a phone that is the instant the title peeks in, and under
     momentum scrolling the 0.95s text cascade had finished before the title
     was comfortably readable, so the entrance looked like it never ran. The
     heading fully inside the viewport, with a margin below it, is the moment a
     reader is actually looking at it on every screen size. */
  function headArrived() {
    var head = section.querySelector(".team-head");
    if (!head) return false;
    var r = head.getBoundingClientRect();
    /* Arrived OR PASSED. Requiring the head to be inside the viewport made the
       window miss-able: a fast flick or an anchor jump can put the head above
       the screen between two scroll events, and a condition that is only true
       while it is in view then never fires again — the copy stayed invisible
       for good. "Its bottom has risen past the readable line" is monotone for
       any downward journey, however fast. */
    return r.height > 0 && r.bottom <= window.innerHeight * 0.92;
  }

  function drop(el) {
    el.classList.add("is-dropped");
  }

  function spread(el) {
    el.classList.add("is-spread");
  }

  /* Where the pile sits inside the section, as a fraction of its height.
     Measured from the chips themselves rather than written as a constant, so
     it follows the frame coordinates in Team.tsx instead of duplicating them —
     and it is the average of the eleven slots, which is the same centroid the
     stylesheet piles them on.

     Measured once and cached: the chips only move when the layout does, and
     eleven getBoundingClientRect calls per scroll frame is exactly the kind of
     per-frame measuring the rest of this page is careful to avoid. */
  var pileFrac = 0.83;

  function measurePile() {
    if (!section) return;
    var slots = section.querySelectorAll(".chip-slot:not(.is-dup)");
    if (!slots.length) return;
    var sr = section.getBoundingClientRect();
    if (!sr.height) return;
    var sum = 0;
    for (var i = 0; i < slots.length; i++) {
      var r = slots[i].getBoundingClientRect();
      sum += r.top + r.height / 2 - sr.top;
    }
    pileFrac = sum / slots.length / sr.height;
  }

  /* True once the pile has risen past the readable line. Same shape as
     headArrived() and monotone for the same reason: "has passed" survives a
     fast flick, where "is inside the viewport" can be skipped between two
     scroll events and then never becomes true again. */
  function pileArrived(r) {
    if (!r.height) return false;
    return r.top + r.height * pileFrac <= window.innerHeight * 0.86;
  }

  /* ————— Marquee progress —————
   * Publishes --tp (0 → 1) on .team: 0 as the section's top reaches the bottom
   * of the viewport, 1 as its bottom leaves the top. The mobile chip rows slide
   * sideways off it, so the bands travel exactly while the section is on screen
   * and are at rest either side of that.
   *
   * Written on .team and not the root for the same reason as the other sections
   * here: a custom property on <html> invalidates style for the whole document,
   * and this updates on every scroll frame.
   *
   * Desktop never reads --tp — the chips are pinned to frame coordinates there —
   * but it is cheap enough to publish unconditionally, and doing so means no
   * stale value if the viewport crosses the breakpoint mid-scroll.
   */
  var section = null;
  var tpTarget = null;   // the smallest element that needs --tp
  var ticking = false;
  var lastTp = -1;

  function tp() {
    ticking = false;
    if (!section || !section.isConnected) return;
    var r = section.getBoundingClientRect();
    var y = window.scrollY;

    /* The nominal range: 0 as the top reaches the bottom of the viewport, 1 as
       the bottom clears the top of it. */
    var from = r.top + y - window.innerHeight;
    var to = r.bottom + y;
    if (from < 0) from = 0;

    /* Clamped to what can actually be scrolled. This is the LAST section on the
       page, so the document runs out while it is still on screen — against the
       nominal range the bands would stop dead at 45% of their travel and the
       rest would be unreachable. Normalising against the reachable distance
       instead means the marquee completes exactly on the final scrollable
       pixel, whatever follows the section. */
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (to > max) to = max;

    /* Second, independent route to the drop. The observer is the primary one,
       but its callbacks are delivered as part of the rendering steps — if those
       are throttled or suppressed the class never lands, and the heading is
       held INVISIBLE waiting for it. Copy that depends on one mechanism firing
       is copy that can vanish; this scroll handler is already running, so
       checking the same condition here costs nothing and makes the text's
       appearance depend on either path rather than both. drop() is idempotent
       and setIdle-style guarded by the class itself. */
    if (!section.classList.contains("is-dropped") && headArrived()) {
      drop(section);
    }
    /* No observer for this one. Unlike the heading — which is held INVISIBLE
       until its class lands, so it needs a second route in case observer
       callbacks are throttled — the chips are already on screen in their pile.
       The worst a missed frame costs here is a late spread, and this handler is
       running on every scroll anyway. The class check short-circuits the rect
       arithmetic once it has fired. */
    if (!section.classList.contains("is-spread") && pileArrived(r)) {
      spread(section);
    }

    var span = to - from;
    if (span <= 0) return;
    var p = (y - from) / span;
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    // Sub-perceptual changes are not worth a style invalidation.
    if (Math.abs(p - lastTp) < 0.0005) return;
    lastTp = p;
    /* Written on the chip list, not the section. A custom property invalidates
       style for everything that inherits it, and this is rewritten on every
       scroll frame — from .team that meant recomputing the heading, the photo
       and all 22 chips 60 times a second, which is what the scrolling was
       stuttering on. Only the four tracks actually read it. */
    tpTarget.style.setProperty("--tp", p.toFixed(4));
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(tp);
  }

  function init() {
    var team = document.querySelector(".team");
    if (!team) return;
    section = team;
    tpTarget = team.querySelector(".team-chips") || team;
    /* Before the first tp(), so the heap is in place for the very first frame
       the section could be painted on — and before any transition exists to
       animate it, which is why the stylesheet declares the move-out on the
       spread state rather than on the pile. */
    team.classList.add("is-piled");
    measurePile();
    tp();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    window.addEventListener("resize", measurePile);
    /* A late webfont changes every chip's width, and with it the centroid. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measurePile);

    /* No observer, or the reader has asked for less motion: land the chips
       immediately. The class is the same one the animation ends on, so the
       resting state is identical either way — there is no separate "static"
       styling to keep in sync. */
    if (!("IntersectionObserver" in window) ||
        (window.matchMedia &&
         window.matchMedia("(prefers-reduced-motion: reduce)").matches)) {
      drop(team);
      spread(team);
      return;
    }

    /* Already in view on load (deep link, refresh partway down): fire now.
       The observer would report this too, but only after a frame, and the
       chips would be visibly mid-air for it. */
    if (headArrived()) {
      drop(team);
      /* Deliberately not spread(): landing partway down the page should still
         show the chips gathered and let them open as the field is reached. tp()
         above has already spread them if the field itself is past. */
      return;
    }

    /* Observing the heading rather than the section, for the reason above.
       The rootMargin trims the bottom so "intersecting fully" means fully
       visible with a little air under it, matching headArrived(). */
    var head = team.querySelector(".team-head") || team;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          drop(team);
          io.disconnect();
          return;
        }
      }
    }, { threshold: 1, rootMargin: "0px 0px -8% 0px" });
    io.observe(head);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ———— counters.js ———— */
/* Nolae About Us — the Numbers section's hero figure, as a slot-machine roll.
 *
 * The reference (user's recording, 2026-08-27) rolls each DIGIT as its own
 * vertical reel: digits stream upward through the slot with a motion blur,
 * ghost digits fading out above and below the line, and the columns settle
 * left to right — the first digit locks while the later ones are still
 * spinning. So this does not count arithmetically; it builds one reel per
 * digit of the finished value and spins each to its target, further columns
 * spinning through more digits for longer.
 *
 * The markup stays the source of truth: the element holds "220,890", the
 * reels are built FROM that text when the section is reached, and the plain
 * text is put back the moment the roll ends — so the resting DOM is exactly
 * the authored DOM, and no-JS or reduced-motion readers simply see the value.
 *
 * Deliberately framework-free (IIFE, no imports, no build step) so it drops
 * into a Shopify Liquid section unchanged:
 *   {{ 'counters.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  // The first column's spin, and how much longer each further column runs.
  var BASE_MS = 1300;
  var STEP_MS = 220;
  // Full 0-9 cycles the first column rolls through; each column adds one more.
  var BASE_CYCLES = 1;

  var section = null;
  var counters = [];
  var fired = false;
  var ticking = false;

  function parse(el) {
    var text = el.textContent.trim();
    if (!/[0-9]/.test(text)) return null;
    return { el: el, final: text };
  }

  /* The rendered advance of one digit, measured — NOT `1ch`. `ch` is defined as
     the advance of the font's "0" glyph and is computed from default glyph
     metrics, so it ignores font-variant-numeric: with Omnes it came out 64.20px
     while the tabular digits actually set at 59.90px. Six digits of that error
     made the reel row 25.8px wider than the finished text, and since the figure
     is centred it visibly jumped sideways the instant the reels were swapped
     back for plain text. Measuring ten zeros in the element's own resolved font
     — variant features included — averages away sub-pixel rounding and makes
     the two layouts identical. */
  function digitWidth(el) {
    var cs = getComputedStyle(el);
    var p = document.createElement("span");
    p.style.position = "absolute";
    p.style.visibility = "hidden";
    p.style.whiteSpace = "pre";
    p.style.fontFamily = cs.fontFamily;
    p.style.fontSize = cs.fontSize;
    p.style.fontWeight = cs.fontWeight;
    p.style.fontStyle = cs.fontStyle;
    p.style.letterSpacing = cs.letterSpacing;
    p.style.fontVariantNumeric = cs.fontVariantNumeric;
    p.textContent = "0000000000";
    document.body.appendChild(p);
    var w = p.getBoundingClientRect().width / 10;
    p.parentNode.removeChild(p);
    return w;
  }

  /* One reel per digit; separators stay as plain, static glyphs. A reel is a
     3em masked window around the line, holding a vertical track of digit
     cells: a blank (so the column starts empty and the digits stream IN, as
     in the reference), then its spin cycles, then 0 up to the target digit.
     Landing is therefore just "translate to the last cell". */
  function buildReels(c) {
    var frag = document.createDocumentFragment();
    var reels = [];
    var dw = digitWidth(c.el);
    for (var i = 0; i < c.final.length; i++) {
      var ch = c.final[i];
      if (ch < "0" || ch > "9") {
        var sep = document.createElement("span");
        sep.className = "roll-sep";
        sep.textContent = ch;
        frag.appendChild(sep);
        continue;
      }
      var slot = document.createElement("span");
      slot.className = "roll";
      slot.style.width = dw.toFixed(3) + "px";
      var win = document.createElement("span");
      win.className = "roll-win";
      var track = document.createElement("span");
      track.className = "roll-track";
      var col = reels.length;
      var html = "<span class=\"roll-cell\">&nbsp;</span>";
      var cycles = BASE_CYCLES + col;
      for (var k = 0; k < cycles; k++)
        for (var d = 0; d <= 9; d++)
          html += "<span class=\"roll-cell\">" + d + "</span>";
      for (var d2 = 0; d2 <= +ch; d2++)
        html += "<span class=\"roll-cell\">" + d2 + "</span>";
      track.innerHTML = html;
      win.appendChild(track);
      slot.appendChild(win);
      frag.appendChild(slot);
      reels.push({
        track: track,
        steps: cycles * 10 + (+ch) + 1,
        dur: BASE_MS + STEP_MS * col,
        prev: 0,
      });
    }
    /* The rebuilt content is presentation; the VALUE for assistive tech is the
       label, which never spins. */
    c.el.setAttribute("aria-label", c.final);
    c.el.textContent = "";
    var wrap = document.createElement("span");
    wrap.setAttribute("aria-hidden", "true");
    wrap.appendChild(frag);
    c.el.appendChild(wrap);
    return reels;
  }

  function start() {
    if (fired) return;
    fired = true;

    if (window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return; // the markup already shows the finished value
    }

    /* Reserve the final width before rebuilding: the reels are 1ch columns and
       may not sum to exactly the kerned text width, and the card must not
       reflow when the plain text is restored at the end. */
    counters.forEach(function (c) {
      c.el.style.display = "inline-block";
      c.el.style.minWidth = c.el.getBoundingClientRect().width + "px";
      c.reels = buildReels(c);
      c.fontPx = parseFloat(getComputedStyle(c.el).fontSize) || 16;
    });

    var t0 = null;
    function frame(now) {
      if (t0 === null) t0 = now;
      var done = true;
      counters.forEach(function (c) {
        c.reels.forEach(function (r) {
          var t = Math.max(0, (now - t0) / r.dur);
          if (t >= 1) {
            if (r.prev !== r.steps) {
              r.prev = r.steps;
              r.track.style.transform = "translateY(" + -r.steps + "em)";
              r.track.style.filter = "";
            }
            return;
          }
          done = false;
          // easeOutQuart: a hard launch decelerating into the landing — the
          // reference's reels brake, they do not glide to a stop.
          var e = 1 - Math.pow(1 - t, 4);
          var y = e * r.steps;
          r.track.style.transform = "translateY(" + -y + "em)";
          /* Blur follows speed. The velocity is measured in em per frame and
             converted to pixels; fast spin smears the digits exactly as the
             recording does, and the blur falls away on its own as the ease
             brakes, so the landing is sharp without a separate "unblur". */
          var v = (y - r.prev) * c.fontPx;
          r.prev = y;
          var blur = Math.min(12, v * 0.35);
          r.track.style.filter = blur > 0.4 ? "blur(" + blur.toFixed(1) + "px)" : "";
        });
      });
      if (!done) { requestAnimationFrame(frame); return; }
      // Roll finished: put the authored text back, exactly as written.
      counters.forEach(function (c) {
        c.el.textContent = c.final;
      });
    }
    requestAnimationFrame(frame);
  }

  function arrived() {
    var r = section.getBoundingClientRect();
    // A third of the card in view — the hero figure sits at its top, so it is
    // on screen and readable when the count begins.
    var vis = Math.min(window.innerHeight, r.bottom) - Math.max(0, r.top);
    return r.height > 0 && vis / Math.min(r.height, window.innerHeight) >= 0.33;
  }

  function check() {
    ticking = false;
    if (!fired && arrived()) start();
  }

  function onScroll() {
    if (fired || ticking) return;
    ticking = true;
    requestAnimationFrame(check);
  }

  function init() {
    section = document.querySelector(".nums");
    if (!section) return;
    counters = [].slice.call(section.querySelectorAll("[data-count]"))
      .map(parse)
      .filter(Boolean);
    if (!counters.length) return;

    if (arrived()) { start(); return; }

    /* Observer where available, and the scroll handler regardless — the same
       two-path arrangement as the team section, for the same reason: a trigger
       the content depends on must not hang off a single delivery mechanism. */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { start(); io.disconnect(); return; }
        }
      }, { threshold: 0.33 });
      io.observe(section);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ———— vimeo-embed.js ———— */
/* Nolae About Us — lazy Vimeo players.
 *
 * Replaces what lazy-video.js used to do for <video data-src>, for the same
 * reasons and with the same thresholds — only the thing being deferred is now
 * a cross-origin player rather than a file.
 *
 * Each embed ships as <iframe data-vimeo="ID"> with NO src, so nothing about
 * Vimeo is fetched — not the player document, not a frame of video — until the
 * clip is within half a screen. That matters more here than it did with files:
 * an unmounted player costs nothing, but eight mounted ones are eight
 * documents each running their own JS.
 *
 * The URL is built here rather than written into the markup so one place owns
 * the flags, and so reduced motion can drop `autoplay` instead of needing a
 * second set of URLs. background=1 is the mode for the clips that are silent
 * forever: no controls, no interaction, autoplay, muted, loop. The testimonial
 * cards need their sound toggled, so they ask for controls=0 and are unmuted
 * through the API by public/testimonials.js.
 *
 * Off-screen players are PAUSED, not unmounted: tearing the iframe down would
 * make coming back a fresh load with a black frame in between. Pausing stops
 * the stream, which is the part worth stopping.
 *
 * player.js is fetched once, on approach, and shared by every embed. Anything
 * needing a Player instance goes through window.__vimeo.player(iframe), which
 * resolves to the same instance however many times it is asked.
 *
 * Deliberately framework-free so it drops into a Liquid section unchanged:
 *   {{ 'vimeo-embed.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  var API = "https://player.vimeo.com/api/player.js";
  var frames = [].slice.call(document.querySelectorAll("iframe[data-vimeo]"));
  if (!frames.length) return;

  var still =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var apiPromise = null;
  function api() {
    if (apiPromise) return apiPromise;
    apiPromise = new Promise(function (resolve, reject) {
      if (window.Vimeo && window.Vimeo.Player) return resolve(window.Vimeo);
      var s = document.createElement("script");
      s.src = API;
      s.async = true;
      s.onload = function () { resolve(window.Vimeo); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return apiPromise;
  }

  /* dnt=1 keeps Vimeo from setting cookies or tracking the visitor, which is
     the right default for a clip used as decoration. */
  function url(el) {
    var id = el.getAttribute("data-vimeo");
    var sound = el.hasAttribute("data-sound");
    var p = ["badge=0", "dnt=1", "app_id=58479"];
    if (sound) {
      /* Not background=1: that mode is built to be silent and takes the
         controls away with it. controls=0 gets the same bare frame while
         leaving the audio addressable. */
      p.push("controls=0", "loop=1", "muted=1", "playsinline=1",
             "title=0", "byline=0", "portrait=0");
      p.push(still ? "autoplay=0" : "autoplay=1");
    } else if (still) {
      /* background=1 forces autoplay, so a reader who has asked for less
         motion gets the plain player parked on its first frame instead. */
      p.push("controls=0", "muted=1", "playsinline=1", "autoplay=0",
             "title=0", "byline=0", "portrait=0");
    } else {
      p.push("background=1");
    }
    return "https://player.vimeo.com/video/" + id + "?" + p.join("&");
  }

  /* Clears the blurred placeholder and the spinner — see .v-poster. Applied to
     the BOX rather than the iframe, because those two are its siblings. */
  function live(el) {
    if (el.__live) return;
    el.__live = true;
    if (el.parentElement) el.parentElement.classList.add("is-live");
  }

  function mount(el) {
    if (el.__mounted) return;
    el.__mounted = true;
    el.src = url(el);
    /* If frames never arrive — a blocked embed, a dead connection — stop the
       spinner but keep the poster. A blurred frame reads as intended; a
       spinner still turning reads as broken.

       20s, not 12: a slow phone on a slow connection legitimately takes ten or
       more to bring up a player, and retiring the spinner while it is still
       genuinely working is the worse mistake. Nothing breaks if this fires
       early — the poster stays and the video appears over it when it lands. */
    setTimeout(function () {
      if (!el.__live && el.parentElement) el.parentElement.classList.add("is-quiet");
    }, 20000);
  }

  /* Resolves to the one Player for this iframe, mounting it first if the
     reader has reached for the sound before the clip came into view. */
  function player(el) {
    if (el.__player) return el.__player;
    mount(el);
    el.__player = api().then(function (V) {
      var p = new V.Player(el);
      var seen = function () { live(el); };
      /* Signals that mean FRAMES ARE ON SCREEN, first one wins — live() is
         idempotent. Measured on one embed, from setting src:

             ready         349ms
             loaded        350ms     <- metadata only
             bufferstart   746ms
             playing      1221ms     <- first frame
             timeupdate   1467ms

         `loaded` and `play` are deliberately NOT in this list. `loaded` means
         a video has been loaded, not started, and it lands within a
         millisecond of ready — accepting it cleared the placeholder at 350 and
         revealed a player that painted nothing for another 870ms, which read
         as the video hanging. `play` is the request, not the picture. */
      ["playing", "timeupdate", "bufferend"].forEach(function (ev) {
        try { p.on(ev, seen); } catch (e) { /* unknown event name */ }
      });

      p.ready()
        .then(function () {
          /* Under reduced motion nothing will ever play and the player parks
             on its own first frame, so ready() IS the handover. */
          if (still) { seen(); return; }
          /* Otherwise: ASK, rather than assume. A blind timer here has the
             same fault as `loaded` did — it reveals the player on a guess
             about how long a start takes, and is wrong on a slow connection
             by however long the start actually took. Polling the paused state
             hands over on the player's own account, whenever that is, and
             gives up after ten seconds so a mode that reports nothing at all
             still ends with the spinner retired by is-quiet. */
          var tries = 0;
          var poll = setInterval(function () {
            if (el.__live || ++tries > 40) { clearInterval(poll); return; }
            p.getPaused()
              .then(function (paused) { if (!paused) { clearInterval(poll); seen(); } })
              .catch(function () {});
          }, 250);
        })
        .catch(function () {});
      return p;
    });
    return el.__player;
  }

  function play(el) {
    if (still) return;
    mount(el);
    player(el).then(function (p) {
      /* ready() first, always. A play() issued before the player has finished
         setting itself up is REJECTED, and since a rejection here is swallowed
         the card would then sit on a black frame indefinitely — which is
         exactly what a first mount looks like, so this is the common case and
         not the edge one. Waiting costs nothing: the clip has its own autoplay
         and is usually already running by the time this resolves.

         Genuine rejections past that point are fine to drop — a policy refusal,
         or the clip having scrolled away again while the call was in flight. */
      return p.ready().then(function () { return p.play(); });
    }).catch(function () {});
  }

  function pause(el) {
    if (!el.__mounted || !el.__player) return;
    el.__player.then(function (p) { p.pause().catch(function () {}); });
  }

  /* player() MOUNTS if it has to, which is right for the card being pressed and
     wrong for the others — silencing a card that was never opened should not
     fetch it. current() answers only for players that already exist. */
  function current(el) { return el.__player || null; }

  window.__vimeo = { player: player, current: current };

  /* Half a screen of lead, matching what the files used to get: enough to have
     buffered before the clip is read, without mounting the whole Culture grid
     at once on a laptop. */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { mount(e.target); play(e.target); }
          else pause(e.target);
        });
      },
      { rootMargin: "50% 0px" }
    );
    frames.forEach(function (f) { io.observe(f); });
  } else {
    frames.forEach(mount);
  }
})();

/* ———— testimonials.js ———— */
/* Nolae About Us — the testimonial video cards' sound, and the cards' arrival.
 *
 * The two clips already play as silent loops: they ship srcless and
 * vimeo-embed.js mounts, mutes and starts them as the cards approach. What
 * that leaves is the button on each card, which is a sound toggle and nothing
 * more — on with one press, off with the next, the clip running throughout.
 * Only one card is ever audible: pressing a second one silences the first.
 *
 * The clips are Vimeo players, so the audio is a setMuted() call through the
 * player API rather than a property on an element — everything here is
 * therefore asynchronous, and the button's state is set optimistically and
 * rolled back if the call is refused.
 *
 * A pause from anywhere puts a card back to silent. vimeo-embed.js pauses a
 * player that scrolls off-screen and resumes it on return, and without this it
 * would come back audible to a reader who had long since scrolled past.
 *
 * The section has no entrance: nothing here is hidden and nothing is armed.
 *
 * Deliberately framework-free so it drops into a Liquid section unchanged:
 *   {{ 'testimonials.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  function setState(btn, on) {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.setAttribute("aria-label", on ? "Turn sound off" : "Turn sound on");
  }

  function init() {
    var section = document.querySelector(".tm");
    if (!section) return;

    var pairs = [];
    var buttons = [].slice.call(section.querySelectorAll(".tm-play"));
    for (var i = 0; i < buttons.length; i++) {
      var card = buttons[i].closest(".tm-card");
      var frame = card && card.querySelector("iframe[data-vimeo]");
      if (frame) pairs.push({ btn: buttons[i], frame: frame });
    }
    if (!pairs.length) return;

    var vimeo = window.__vimeo;
    if (!vimeo) return; /* nothing to toggle; the clips still run silently */

    function noop() {}

    /* Silences a card. Only reaches for a player that already exists: a card
       the reader never opened should not be mounted just to mute it. */
    function silence(pair) {
      setState(pair.btn, false);
      var p = vimeo.current(pair.frame);
      if (p) p.then(function (pl) { pl.setMuted(true).catch(noop); });
    }

    pairs.forEach(function (pair) {
      pair.btn.addEventListener("click", function () {
        if (pair.btn.getAttribute("aria-pressed") === "true") {
          silence(pair);
          return;
        }
        pairs.forEach(function (other) { if (other !== pair) silence(other); });

        /* Optimistic: the glyph flips now and is put back if Vimeo refuses.
           Waiting on the round trip would leave the button dead for a beat
           after a deliberate press. */
        setState(pair.btn, true);
        vimeo.player(pair.frame).then(function (pl) {
          /* Attached on first use rather than at start-up, since that is the
             earliest a player exists. Guarded so a second press does not stack
             another listener. */
          if (!pair.bound) {
            pair.bound = true;
            pl.on("pause", function () {
              if (pair.btn.getAttribute("aria-pressed") === "true") silence(pair);
            });
          }
          return pl.setMuted(false).then(function () {
            /* Normally already running; this only matters where the silent
               autoplay had been refused, in which case the press is the
               gesture that allows it. */
            return pl.play().catch(noop);
          });
        }).catch(function () { silence(pair); });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ———— reveal.js ———— */
/* Nolae About Us — hold an entrance until its section is reached.
 *
 * The hero plays on load; "Meet the team", "Culture at Nolae" and "Content
 * House of K-pop" each wait, and each is released by a class their own script
 * already adds while measuring something else every frame. A section with no
 * such section — "What they're saying" — needs the class from somewhere, and
 * adding a stage to page-tone.js just to get it would mean claiming a tone the
 * section does not have.
 *
 * So: mark a section `data-reveal="<selector>"`, where the selector picks the
 * element whose arrival should trigger it, and this adds `is-arrived` to the
 * section once that element comes into view. Same class the other sections
 * use, so the CSS reads identically.
 *
 * An IntersectionObserver rather than a scroll handler, because nothing else
 * here needs measuring per frame — this fires once and stops. The -8% bottom
 * margin matches the 0.92-of-a-viewport threshold the scroll-driven sections
 * use, so every entrance on the page trips at the same depth.
 *
 * If this never runs the CSS leaves the text plainly visible: the entrance is
 * additive, never a precondition for reading the page.
 *
 * Liquid: {{ 'reveal.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  function init() {
    var sections = document.querySelectorAll("[data-reveal]");
    if (!sections.length) return;

    if (!("IntersectionObserver" in window)) {
      for (var i = 0; i < sections.length; i++) {
        sections[i].classList.add("is-arrived");
      }
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var anchor = entries[i].target;
          (anchor.__section || anchor).classList.add("is-arrived");
          io.unobserve(anchor);
        }
      },
      { rootMargin: "0px 0px -8% 0px" }
    );

    for (var j = 0; j < sections.length; j++) {
      var section = sections[j];
      var anchor = section.querySelector(section.getAttribute("data-reveal")) || section;
      anchor.__section = section;
      io.observe(anchor);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ———— download-parallax.js ———— */
/* Nolae About Us — the closing panel's entrance.
 *
 * Modelled on the "get the app" section at wickret.cuberto.com. Its contents
 * do not simply scroll with the panel: they sit high while it is coming up and
 * converge on their resting place as it reaches the top of the screen, so the
 * block arrives before the words settle inside it.
 *
 * The rule was measured off that page rather than guessed. Sampling its content
 * transform against the section's position gives a straight line at 0.44,
 * clamped once the section is a full screen away:
 *
 *     sectionTop  1140   540   420   260   120    60     0
 *     offset      -314  -237  -185  -113   -54   -25     0
 *
 *     y = -0.44 * min(max(sectionTop, 0), viewportHeight)
 *
 * which reproduces every one of those to within a pixel.
 *
 * Publishes a length; the stylesheet does the moving. Reduced motion gets the
 * panel with no drift at all — the offset is decoration, and the section reads
 * exactly the same without it.
 *
 * Framework-free so it drops into Liquid unchanged:
 *   {{ 'download-parallax.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  var RATE = 0.44;

  function init() {
    var section = document.querySelector(".dl");
    if (!section) return;

    if (window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    var ticking = false;
    var last = null;

    function frame() {
      ticking = false;
      var top = section.getBoundingClientRect().top;
      var vh = window.innerHeight;
      /* Below the fold it holds at the clamp; above the top it stays put. */
      var travel = top < 0 ? 0 : top > vh ? vh : top;
      var y = -(RATE * travel).toFixed(1);
      if (y === last) return;
      last = y;
      section.style.setProperty("--dl-y", y + "px");
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }

    addEventListener("scroll", onScroll, { passive: true });
    addEventListener("resize", onScroll);
    frame();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
